import { UIText2 } from '@cian/ui-kit/typography';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Underground.css';
import { UndergroundIcon } from './components/UndergroundIcon';
import { ETransportType } from '../../../types/geo';
import { GeoTravelTime } from '../../GeoTravelTime';

export interface IUndergroundProps {
  lineColor?: string | null;
  name: string;
  regionId: number[];
  time?: string | null;
  transportType?: ETransportType | null;
  underConstruction: boolean;
}

export const Underground: React.FC<IUndergroundProps> = ({
  lineColor,
  name,
  regionId,
  time,
  transportType,
  underConstruction,
}) => {
  return (
    <div className={classNames(styles['container'], { [styles['container--under-construction']]: underConstruction })}>
      {lineColor && <UndergroundIcon className={styles['icon']} color={`#${lineColor}`} regionId={regionId} />}
      <span className={styles['name']}>
        <UIText2 display="inline">{name}</UIText2>
      </span>
      {time && transportType && <GeoTravelTime time={time} transportType={transportType} />}
    </div>
  );
};
